export default __webpack_public_path__ + "static/media/landing-page-layout-background.7519afd2.svg";